import React from "react";
import { ProductName } from "types/general";

export const getHeading = (productName: ProductName) => {
  switch (productName) {
    case ProductName.taxRefundAdvance:
      return "Tell us about yourself.";
    case ProductName.earnedWageAccess:
    default:
      return <>Next we'll verify your&nbsp;identity.</>;
  }
};

export const getSubheading = (productName: ProductName) => {
  switch (productName) {
    case ProductName.taxRefundAdvance:
      return "We'll use this information to start filling out your tax return.";
    case ProductName.earnedWageAccess:
    default:
      return null;
  }
};

export const getDobHelpMessage = (productName: ProductName) => {
  switch (productName) {
    case ProductName.taxRefundAdvance:
      return "You must be 18 years of age or older to use the tax filing service.";
    case ProductName.earnedWageAccess:
    default:
      return "Reset cardholders must be 18 years of age or older.";
  }
};

export const getSsnHelpMessage = (productName: ProductName) => {
  switch (productName) {
    case ProductName.taxRefundAdvance:
      return "The IRS needs this to verify your identity.";
    case ProductName.earnedWageAccess:
    default:
      return "We need this to verify your identity.";
  }
};
